function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import RESTAdapter from '@ember-data/adapter/rest';
import { apiHost } from '@square/environment-utils/api-urls';
// eslint-disable-next-line dashboard/use-utilities-window
import window from 'ember-window-mock';
export function getChannelsHost() {
  const protocol = new URL(window.location.origin).protocol;
  return `${protocol}//${apiHost(window.location.host)}`;
}
export const channelsHost = getChannelsHost();
export default class BaseChannel extends RESTAdapter {
  constructor(arg) {
    super(arg);
    _defineProperty(this, "useFetch", void 0);
    _defineProperty(this, "host", channelsHost);
    this.useFetch = false;
  }
  ajaxOptions(url, method, options) {
    // We need to set this for CORS requests
    // eslint-disable-next-line no-param-reassign
    options.xhrFields = {
      withCredentials: true
    };
    return super.ajaxOptions(url, method, options);
  }
}